import * as React from 'react';
//import SvgIcon from '@mui/material/SvgIcon';

export default function SitemarkIcon() {

    return (
        <div
            style={{
                paddingLeft: '3rem',
                fontSize: '1.4rem',
                color: 'hsl(15, 100%, 20%)',
                fontWeight: '700',
            }}
        >
            OrangeVulpes
        </div>
    );
}
